<template>
  <dialog-view
      :open="open"
      title="Добавить в чат"
      @cancel="close()"
  >
    <template v-slot:content>
      <div class="mb-2">Пользователи МИС</div>
      <user-autocomplete-multiple :key="'admin-' + chatId" :select.sync="chatAdminUsers" name="Администраторы"
                                  _type="admin"/>
      <user-autocomplete-multiple :key="'spec-' + chatId" :select.sync="chatSpecUsers" name="Специалисты" _type="spec"/>
      <user-autocomplete-multiple :key="'client-' + chatId" :select.sync="chatClientUsers" name="Клиенты"
                                  _type="client"/>
      <dialog-user-autocomplete-multiple :key="'du-' + chatId" :select.sync="chatDialogUsers"
                                         name="Пользователи Мессенджера"/>
    </template>
    <template v-slot:actions>
      <v-btn
          :disabled="
            chatAdminUsers.length === 0 &&
            chatSpecUsers.length === 0 &&
            chatClientUsers.length === 0 &&
            chatDialogUsers.length === 0
          "
          :loading="chatState.loading" color="primary" text @click="chat()">
        Добавить
      </v-btn>
    </template>
  </dialog-view>
</template>

<script>
import DialogView from "@/components/DialogView.vue";
import UserAutocompleteMultiple from "@/componentsV2/custom/UserAutocompleteMultiple.vue";
import axios from "axios";
import Stater from "../../../../plugins/stater";
import DialogUserAutocompleteMultiple from "../../../../componentsV2/custom/DialogUserAutocompleteMultiple.vue";

export default {
  components: {DialogUserAutocompleteMultiple, DialogView, UserAutocompleteMultiple},
  props: ['open', 'chatId'],
  data: () => ({
    chatAdminUsers: [],
    chatSpecUsers: [],
    chatClientUsers: [],
    chatDialogUsers: [],
    chatState: new Stater(),
  }),
  watch: {
    open(v) {
      if (v) this.reset();
    },
  },
  methods: {
    reset() {
      this.chatAdminUsers = [];
      this.chatSpecUsers = [];
      this.chatClientUsers = [];
      this.chatDialogUsers = [];
      this.chatState.stateInit();
    },
    close() {
      this.reset();
      this.$emit('cancel');
    },
    chat() {
      this.chatState.stateLoading();
      axios.post('/napi/dialog/chat/' + this.chatId + '/join/', {
        userIds: [
          ...this.chatAdminUsers.map(v => v.id),
          ...this.chatSpecUsers.map(v => v.id),
          ...this.chatClientUsers.map(v => v.id),
        ],
        dialogUserIds: this.chatDialogUsers.map(v => v.id),
      })
          .then(r => {
            this.chatState.stateSuccess();
            this.$emit('invited', r.data);
            this.close();
          })
          .catch(e => {
            this.chatState.stateError(e.response?.data?.message);
          });
    },
  },
}
</script>
